import {
  Component,
  ElementRef,
  forwardRef,
  inject,
  Input,
  input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PayeeRippleDirective } from '../../payee-ripple/payee-ripple.directive';

@Component({
  selector: 'button[payee-mini-icon-button]',
  templateUrl: './payee-mini-icon-button.component.html',
  styleUrls: ['./payee-mini-icon-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayeeMiniIconButtonComponent),
      multi: true,
    },
  ],
  imports: [PayeeRippleDirective],
  host: {
    '[class.payee-border-button]': 'isBorderButton()',
    '[attr.color]': 'color()',
  },
})
export class PayeeMiniIconButtonComponent implements ControlValueAccessor {
  private ref = inject<ElementRef<HTMLButtonElement>>(ElementRef);

  element: HTMLButtonElement;

  @Input() disableRipple = false;
  readonly isBorderButton = input(false);
  readonly color = input('blue-payee');

  constructor() {
    this.element = this.ref.nativeElement;
  }

  // ControlValueAccessor
  onChange = (_obj: any) => {};

  onTouched = () => {};

  writeValue(obj: any): void {
    this.onChange(obj);
  }

  setDisabledState(_isDisabled: boolean): void {}

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  registerOnChange(fn: (obj: any) => void): void {
    this.onChange = fn;
  }
}
